import { useEffect, useState } from "react";

export function useServiceWorkerVersion() {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg?.active) {
          reg.active.postMessage({ type: "GET_VERSION" });
          navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data.type === "VERSION") {
              setVersion(event.data.payload);
            }
          });
        }
      });
    }
  }, []);

  return version;
}